import React from 'react';
import HBCheckbox, { ICheckboxBase } from '../HBCheckbox/HBCheckbox';
import HBBaseFormField, {
    HBBaseFormFieldProps,
    splitFieldProps
} from '../HBBaseFormField/HBBaseFormField';

export type HBCheckboxFieldProps = Omit<
    HBBaseFormFieldProps,
    'size' | 'labelSize'
> &
    ICheckboxBase & {
        /** HTML `id` for the field; used as the `<label htmlFor>` target so clicking the label toggles the checkbox. Required. */
        id: string;
        /** Ref forwarded to the underlying checkbox input element. */
        inputRef?: React.Ref<HTMLInputElement>;
        /** Places the label to the left or right of the checkbox; the field wrapper size is auto-corrected one step up from the checkbox size. */
        placement?: 'left' | 'right';
        /** Enables DS Next visual styling (updated disabled colors and label alignment). Temporary flag — will be removed after the DS Next migration. @deprecated */
        isDSNext?: boolean;
        /** @deprecated Use `onKeyDown` instead. Fires on key press inside the checkbox input. */
        onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    };

const SIZE_CORRECTION_MAP: Record<ICheckboxBase['size'], any> = {
    sm: 'md',
    md: 'lg',
    lg: 'xl'
};

const HBCheckboxField = ({
    inputRef,
    size = 'md',
    placement = 'right',
    ...props
}: HBCheckboxFieldProps) => {
    const { fieldProps, inputProps } = splitFieldProps(props);

    return (
        <HBBaseFormField
            {...fieldProps}
            size={SIZE_CORRECTION_MAP[size]}
            placement={placement}
            isDSNext
        >
            <HBCheckbox {...inputProps} ref={inputRef} size={size} />
        </HBBaseFormField>
    );
};

export default HBCheckboxField;
